import { useState, useEffect } from "react";
import { Button } from "@zapier/design-system-beta";
import { Alert, AlertDescription, Icon, Text } from "@zapier/design-system";
import { AlertPositioner } from "../AlertPositioner";
import styles from "./WhatsNewAlert.module.css";

const URL = "https://www.loom.com/share/placeholder";
const DISMISSED_KEY = "whats-new-alert-dismissed";

export function WhatsNewAlert() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(!localStorage.getItem(DISMISSED_KEY));
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(DISMISSED_KEY, "true");
    setIsVisible(false);
  };

  const handleWhatsNewClick = () => {
    window.open(URL, "_blank");
  };

  if (!isVisible) {
    return null;
  }

  return (
    <AlertPositioner>
      <Alert onDismiss={handleDismiss} status="info" variant="toast">
        <AlertDescription>
          <Text type="Body3">
            {
              "We're refreshing Canvas with a cleaner, more intuitive look—rolling out next week."
            }
          </Text>
          <div className={styles.buttonWrapper}>
            <Button
              variant="primary"
              size="small"
              onPress={handleWhatsNewClick}
            >
              {`See what's coming`}
              <Icon name="arrowBigRight" size="small" />
            </Button>
          </div>
        </AlertDescription>
      </Alert>
    </AlertPositioner>
  );
}
